import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { accountService } from '@kss/api';
import type { AccountCreate } from '@kss/api';
import { loadAccountOptions } from '../shared/formLoaders';

const columns: BulkColumn<AccountCreate>[] = [
  { key: 'code', header: 'Code', sample: '1000' },
  { key: 'name', header: 'Name', required: true, sample: 'Cash' },
  { key: 'accountType', header: 'Type', sample: 'Asset' },
  { key: 'parentAccountId', header: 'Parent', dataType: 'lookup', loadOptions: loadAccountOptions },
  { key: 'description', header: 'Description' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkAccount() {
  return (
    <BulkSpreadsheet<AccountCreate> title="Bulk import accounts" entityLabel="account" backPath="/panel/accounts" columns={columns} module="Account"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await accountService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
